import { Accordion, Container, Title, List } from '@mantine/core';
import classes from './Faq.module.css';

export function Faq() {
  return (
    <Container component={'section'} size="lg" className={classes.wrapper} id="preguntas-frecuentes">
      <Title ta="center" className={classes.title}>
        Preguntas frecuentes
      </Title>

      <Accordion variant="separated">
        <Accordion.Item className={classes.item} value="documentation">
          <Accordion.Control className={classes.customControl}>
            ¿Cuáles son los documentos necesarios para solicitar un préstamo?
          </Accordion.Control>
          <Accordion.Panel>
            Se necesitan 4 documentos para poder recibir un préstamo por tu auto:
            <List mt={5} withPadding>
              <List.Item>Factura original del auto</List.Item>
              <List.Item>Tarjeta de circulación</List.Item>
              <List.Item>Identificación oficial vigente</List.Item>
              <List.Item>Comprobante de domicilio no mayor a 60 días.</List.Item>
            </List>
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item className={classes.item} value="loan-types">
          <Accordion.Control className={classes.customControl}>
            ¿Qué tipos de préstamos ofrecen?
          </Accordion.Control>
          <Accordion.Panel>
            Ofrecemos préstamos personales con plazos flexibles y tasas competitivas. Están
            diseñados para cubrir necesidades como imprevistos, deudas, educación o proyectos
            personales.
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item className={classes.item} value="approval-time">
          <Accordion.Control className={classes.customControl}>
            ¿Cuánto tiempo tarda en aprobarse mi solicitud?
          </Accordion.Control>
          <Accordion.Panel>
            Las solicitudes se procesan el mismo día. En la mayoría de los casos, recibirás una
            respuesta en menos de 24 horas hábiles.
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item className={classes.item} value="deposit-time">
          <Accordion.Control className={classes.customControl}>
            ¿Cuándo recibiré el dinero?
          </Accordion.Control>
          <Accordion.Panel>
            Una vez aprobado tu préstamo, el depósito se realiza el mismo día hábil, usualmente en
            menos de 24 horas.
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item className={classes.item} value="late-payment">
          <Accordion.Control className={classes.customControl}>
            ¿Qué pasa si no puedo pagar a tiempo?
          </Accordion.Control>
          <Accordion.Panel>
            Si tienes dificultades para pagar, te recomendamos contactarnos lo antes posible.
            Podemos ayudarte a reestructurar tu plan de pago y evitar cargos adicionales.
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
}
